import api from '@ibkr/clientportal.common/src/api/index'
import ibcustApi from '@ibkr/clientportal.common/src/api/ibcustApi'
import cqeApi from '@ibkr/clientportal.common/src/api/cqe'
import mdApi from '@ibkr/clientportal.common/src/api/mdApi'
import hmdsApi from '@ibkr/clientportal.common/src/api/hmdsApi'
import iserverApi from '@ibkr/clientportal.common/src/api/iserverApi'
import {progressStart,progressEnd} from '@ibkr/lib.common/src/js/progress'
import IntervalTimer from '@ibkr/clientportal.common/src/js/interval'
import { httpFailed, httpStatus, httpError } from '@ibkr/clientportal.common/src/js/http'
import { Settings } from '@ibkr/clientportal.common/src/js/settings'
import iaPromoApi from '@ibkr/clientportal.common/src/api/iaPromoApi'
import { safeCall } from '@ibkr/clientportal.common/src/js/promise'
import * as types from './mutation-types'

let sh = 0; // set timeout handler for tickle session
const bagConidPattern = /.*;.*\//;

export const triggerEvent = ({ commit, dispatch, state }, event) =>
    commit(types.TRIGGER_EVENT, event);

export const setAccountSummary = ({ commit, dispatch, state }, data) =>
    commit('portfolio/SET_ACCOUNT_SUMMARY', data);

const doTickleSession = ({ commit, dispatch, state, getters }, uid, wbId) =>
    api.tickleSession()
        .then(res => {
            if (res?.redirected) {
            	// can happen when there's an error or request is redirected
                window.app.$alert(window.app.$t('tickle_reload_page'), {
                    verb: window.app.$t('ok'),
                    action: (obj) => {
                        location.reload();
                    },
                    dismissable: false
                });
            } else {
                return res;
            }
        })
        .then(res => {
            // update AM status
            commit(types.SET_AM_STATUS, res.amStatus?.status);
            /**
             * Use iserver accounts as picker accounts if:
             * 1. There is partial service interruption AND
             * 2. Picker accounts are not already set AND
             * 3. Iserver accounts are available
             */
            if (getters.partialServiceInterruption && (getters.pickerAccounts.length == 0)
                    && (getters['iserverData/accounts'].length != 0)) {
                dispatch('iserverData/setIserverAccountsAsPickerAccounts', {});
            }

            // update iserver auth status
            dispatch('iserverData/onAuthStatus', res.iserver?.authStatus || {});
            dispatch('iserverData/onAuthStatus', { backendDown: false });

            // don't perform user id mismatch check in dev environment
            if ($build.mode == 'development') {
                return;
            }
            if (uid != 0 && res && res.userId && res.userId != uid) {
                console.debug('user id mismatch', uid, res.userId);
                window.app.$alert(window.app.$t('logged_out_by_another_session'), {
                    action: () => {
                        dispatch('goToLoginPage', {}); // don't call out logout.
                    }
                });
            }
        })
        .catch(res => {
            const status = httpStatus(res);
            if (status == 401) {
                dispatch('triggerEvent', {
                    'name': 'ON_LOGOUT',
                    'component': undefined,
                    'payload': true
                });
            } else if (status == 500) {
                // 500 status indicates backend is down
                // TODO: move backendDown flag outside of iserver modle as it now also contains AM status
                dispatch('iserverData/onAuthStatus', { backendDown: true });
            }
        });

export const tickleSession = ({ commit, dispatch, state, getters }) => {
    if (sh == 0) {
        const uid = (state.sso && state.sso.USER_ID) || 0;
        sh = setInterval(() => doTickleSession( { commit, state, dispatch, getters }, uid), 30000);
    }
}

export const setFromMobile = ({ commit, dispatch, state }, data) =>
    commit(types.SET_FROM_MOBILE, data);

export const getAllBalancesSummary = ({ commit, dispatch, state }, { el, acctIds, onSuccess, onError }) => {
    progressStart(el);
    return api.getAllBalancesSummary(acctIds)
        .then((res) => {
            commit(types.SET_BALANCE_SUMMARY, res);
            safeCall('get all balance summary', onSuccess, res);
            progressEnd(el);
        })
        .catch((result) => {
            safeCall('get all balance summary', onError, result);
            httpFailed('get all balance summary', commit, result);
            progressEnd(el);
        });
}

export const getCompetitors = ({ commit, dispatch, state }, payload) =>
    api.getCompetitors()
        .then((res) => {
            commit(types.SET_COMPETITORS, res);
            if (payload && payload.onSuccess) payload.onSuccess();
        })
        .catch((result) => {
            if (payload && payload.onError) payload.onError(result);
            httpFailed("get competitors ", commit, result)
        });

export const getFundamentals = ({ commit, dispatch, state }, { conid, onSuccess = null, onError = null}) => {
    commit(types.SET_FUNDAMENTALS, { conid: conid, data: {} });
    return api.getFundamentals(conid)
        .then((res) => {
            if (res.error) {
                safeCall('get-fundamentals', onError, res);
            } else {
                commit(types.SET_FUNDAMENTALS, { conid: conid, data: res });
                safeCall('get-fundamentals', onSuccess, res);
            }
        })
        .catch((result) => {
            safeCall('get-fundamentals', onError, result);
            httpFailed("get fundamentals ", commit, result);
        });
}


export const getNews = ({ commit, dispatch, state }, { conid, el, lastNewsId, onSuccess = null}) => {
    progressStart(el)
    return api.getNews(conid, lastNewsId)
        .then((res) => {
            progressEnd(el);
            commit(types.SET_NEWS, { conid: conid, data: res });
            if (onSuccess) onSuccess(res);
        })
        .catch((result) => {
            progressEnd(el);
            httpFailed("get news ", commit, result);
        });
}

export const getNewsContent = ({ commit, dispatch, state }, { id, onSuccess, el }) => {
    if (state.newsContent[id] !== undefined) {
        onSuccess();
        return;
    }
    progressStart(el)
    return api.getNewsContent(id)
        .then((res) => {
            progressEnd(el);
            res['id'] = id;
            commit(types.SET_NEWS_CONTENT, { newsId: id, data: res });
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            progressEnd(el);
            httpFailed("get news content ", commit, result);
        });
}

/**
 * @Deprecated
 * Should be removed once WEBPLTFRM-801 is released
 */
export const getPerformanceData = ({ commit, dispatch, state }, { acctIds, period, benchmarks, el, onSuccess, onError, retry=1 }) => {
    progressStart(el);
    return api.getPerformanceData(acctIds, period, benchmarks)
        .then((res) => {
            commit(types.SET_PERFORMANCE, res);
            if (res.tpps && res.tpps.data[0]) {
                commit(types.SET_RATES, res.tpps.data[0]);
            } else {
                httpFailed("bad response data", commit, res)
            }
            safeCall('get performance data', onSuccess, res);
            progressEnd(el);
        })
        .catch((result) => {
            progressEnd(el);
            if (++retry > 3) {
                if (result.response && result.response.data && result.response.data.code) {
                    commit(types.SET_PERFORMANCE, result.response.data);
                    commit(types.SET_RATES, result.response.data);
                }
                safeCall('get performance data', onError, result);
                httpFailed("get performance data ", commit, result);
            } else {
                dispatch('getPerformanceData', { acctIds, period, benchmarks, el, onSuccess, onError, retry });
            }
        });
}

/**
 * @Deprecated
 * Should be removed once benchmark data is used from allperiods API
 */
export const getBenchmarkData = ({ commit, dispatch, state }, { acctIds, period, benchmarks, el, onSuccess, onError, retry=1 }) => {
    progressStart(el);
    return api.getPerformanceData(acctIds, period, benchmarks)
        .then((res) => {
            safeCall('get performance data', onSuccess, res);
            progressEnd(el);
        })
        .catch((result) => {
            progressEnd(el);
            if (++retry > 3) {
                safeCall('get benchmark data', onError, result);
                httpFailed("get benchmark data ", commit, result);
            } else {
                dispatch('getBenchmarkData', { acctIds, period, benchmarks, el, onSuccess, onError, retry });
            }
        });
}

export const getPerformanceAllPeriods = ({ commit, dispatch, state }, { acctIds, model, el, benchmarks, onSuccess, onError, retry=1 }) => {
    progressStart(el);
    return api.getPerformanceAllPeriods(acctIds, model, benchmarks)
        .then((res) => {
            commit(types.SET_PERFORMANCE, res);
            safeCall('get performance data for all periods', onSuccess, res);
            progressEnd(el);
        })
        .catch((result) => {
            progressEnd(el);
            if (++retry > 3) {
                if (result.response && result.response.data && result.response.data.code) {
                    commit(types.SET_PERFORMANCE, result.response.data);
                }
                safeCall('get performance data for all periods', onError, result);
                httpFailed("get performance data for all periods", commit, result);
            } else {
                dispatch('getPerformanceAllPeriods', { acctIds, model, el, benchmarks, onSuccess, onError, retry });
            }
        });
}

export const getUser = (args, payload) =>
    ibcustApi.getUser()
        .then((res) => {
            if (!res || !res.username) {
                throw "Missing username in response";
                return;
            }
            if (res && res.uar) {
                args.dispatch('triggerEvent', {
                    'name': 'ON_UAR_CHANGED',
                    'component': null,
                    'payload': res.uar
                });
            }

            args.commit(types.SET_USER, res);
            if (payload && payload.onSuccess) payload.onSuccess(res);
            if (args.getters.wbId) {
                args.dispatch('getMktAm', { id: args.getters.wbId });
            } else {
                args.commit(types.SET_NOTIFICATION_ICON_URL, 'static/cp_favicon196.png');
                args.commit(types.SET_FAVICON_URL, 'static/cp_favicon32.png');
            }
        })
        .catch((result) => {
            const username = args.state.user && args.state.user.username;
            if (payload && payload.onError) payload.onError(result);
            httpFailed("get user failed", args.commit, result);
            setTimeout(() => args.dispatch('getUser', payload), 3000);
        });

export const getPriceHistory = ({ commit, dispatch, state, getters }, { conid, period, bar, source, outsideRth, onSuccess, onError }) => {
    const localApi = getters['abFeatures/showDirectHMDS'] ? hmdsApi : iserverApi;
    return localApi.getPriceHistory(conid, period, '', source, bar, outsideRth)
        .then((res) => {
            if (res.data) {
                commit(types.SET_PRICE_HISTORY, { conid: conid, data: res });
                if (onSuccess) onSuccess();
            } else if (onError){
                commit(types.CLEAR_PRICE_HISTORY);
                onError(res)
            } else {
                httpFailed("get price history ", commit, result)
            }
        })
        .catch((result) => {
            if (onError) onError(result);
            httpFailed("get price history ", commit, result)
        });
}

export const getRegionMarkets = ({ commit, dispatch, state }, { region, onSuccess }) =>
    api.getRegionMarkets(region)
        .then((res) => {
            commit(types.SET_MARKETS, res);
            if (onSuccess) onSuccess();
        })
        .catch((result) => {
            httpFailed("get region markets ", commit, result);
        });

export const setUAR = ({ commit, dispatch, state }, data) => {
    return commit(types.SET_UAR, data);
}

export const getSecdefs = ({ commit, dispatch, state }, { conids, onSuccess, onError }) => {
    // secdef request is not supported for combo conids
    conids = (conids || []).filter(c => !bagConidPattern.test(c));
    if (conids.length === 0) {
        return;
    }
    const filteredConids = conids.filter(c => !state.secdefData[c]);
    if (filteredConids.length === 0) {
        const result = conids.map(c => state.secdefData[c]);
        safeCall('action get secdef', onSuccess, result);
        return;
    }
    return api.getSecdefs(filteredConids)
        .then(res => {
            const arr = res && res.secdef;
            if (arr) {
                for (let y = 0; y < arr.length; y++) {
                    const item = arr[y];
                    if (!(item instanceof Object) || Object.keys(item).length == 0) {
                        // ignore empty item
                    } else if (item.conid) {
                        commit(types.SET_SECDEF_DATA, { conid: item.conid, data: item })
                    } else {
                        console.error("conid missing in get secdef data", res);
                    }
                }
            }
            const result = conids.map(c => state.secdefData[c]);
            safeCall('action get secdef', onSuccess, result);
        });
}

export const getMktAm = ({ commit, dispatch, state }, { id: wbId }) =>
    api.getMktAm(wbId).then(res => {
        window.wbAm = res;
        const wbInfo = {};
        if (res) {
            const address = res.getElementsByTagName('address');
            if (address && address[0]) {
                wbInfo.email = address[0].textContent;
            }
            const cs = res.getElementsByTagName('customer_service');
            if (cs && cs[0]) {
                wbInfo.customer_service = cs[0].getAttribute('url');
            }
            const customerServiceFlag = res.getElementsByTagName('customerServiceFlag');
            if (customerServiceFlag && customerServiceFlag[0]) {
                wbInfo.customer_service_flag = customerServiceFlag[0].getAttribute('flag');
            }
            const wbName = res.getElementsByTagName('whitebranding_name');
            if (wbName && wbName[0]) {
                wbInfo.whitebranding_name = wbName[0].textContent;
            }

            const banner = res.getElementsByTagName('banner') || [];
            for (let x = 0; x < banner.length; x++) {
                const b = banner[x];
                const name = (b && b.getAttribute('name')) || '';
                const src = (b && b.getAttribute('src')) || '';
                if (name && src) {
                    wbInfo[name] = src;
                }
            }
        }
        commit(types.SET_BRAND_INFO, wbInfo);
        if (wbInfo.am_favinco) {
            args.commit(types.SET_FAVICON_URL, '/' + wbInfo.am_favinco);
        }
        window.app && window.app.$util && window.app.$util.cookie('parnerID', wbId);
    });

export const setSelectedAccounts = ({ commit, dispatch, state }, { accounts, onSuccess, onError }) => {
    commit(types.SET_SELECTED_ACCOUNTS, accounts);
    const username = state.user && state.user.username;
    return dispatch('triggerEvent', {
        'name': 'ON_SELECTED_ACCOUNTS',
        'component': null,
        'payload': accounts
    });
}

export const onSsoValidated = (args, authenticated) => {
    args.commit(types.SET_SSO_VALIDATED, authenticated);
    return args.dispatch('triggerEvent', {
        'name': 'ON_SSO_VALIDATED',
        'component': null,
        'payload': authenticated
    });
}

export const setEventListeners = ({ state, commit, dispatch }, events) =>
    commit(types.SET_EVENT_LISTENERS, events);

export const getFutureContracts = ({ commit, dispatch, state }, { symbols, onSuccess, onError }) =>
    api.getFutureContracts(symbols).then((res) => {
        if (res.error) {
            safeCall('getOverview: get overview', onError, {});
        } else {
            safeCall('getOverview: get overview', onSuccess, res);
        }
    })
    .catch((result) => {
        safeCall('getOverview: get overview', onError, {});
        httpFailed('getOverview: get overview', commit, result);
    });

export const storePickerAccounts = ({ commit, dispatch, state }, { accts, onSuccess, onError }) => {
    if (accts) {
        commit(types.SET_PICKER_ACCOUNTS, accts);
        safeCall('storePickerAccounts: success', onSuccess, {});
    } else {
        safeCall('storePickerAccounts: invalid accounts', onError, {});
    }
}

export const routeLoading = ({ commit, dispatch, state }, { status }) =>
    commit(types.ROUTE_LOADING, status);

export const privacyMode = ({ commit, dispatch, state }, { status }) =>
    commit(types.PRIVACY_MODE, status);

export const getAccountProperties = ({ commit, dispatch, state }, { accountIds, retry = 1 }) => {
    if (retry > 3) {
        console.error('Failed to get account properties. Stopped requesting');
        return;
    }
    return api.getAccountProperties(accountIds)
        .then(res => {
            // if user properties are absent, retry
            if (Object.keys((res?.userProperties) || {}).length == 0) {
                console.debug(`User properties empty. Retrying..`);
                setTimeout(() => dispatch('getAccountProperties', { accountIds, retry: ++retry }), 1000);
            } else {
                commit(types.SET_ACCOUNT_PROPERTIES, res);
            }
        })
        .catch(e => {
            // retry
            console.debug(`Failed to get account properties: ${e}. Retrying..`);
            setTimeout(() => dispatch('getAccountProperties', { accountIds, retry: ++retry }), 1000);
        });
}

export const goToLoginPage = ({ commit, dispatch, state, getters }, {}) => {
    const urlParam = $util.cookie('URL_PARAM') || '';
    let partnerId = '';
    if (getters.wbId) {
        partnerId = '&partnerID=' + getters.wbId;
    }
    let href = '/sso/Logout?';
    if (urlParam) {
        href += urlParam;
    }
    if (partnerId) {
        href += partnerId;
    }
    location.href = href;
}

export const getAccountStatus = ({ commit }, { data } ) => {
    return new Promise((resolve, reject) => {
        ibcustApi.getAccountStatus(data)
            .then(res => {
                commit(types.SET_ACCOUNT_STATUS, { res, data });
                resolve(res);
            })
            .catch(err => {
                httpFailed('Failed to get account status', commit, err);
                reject(err);
            });
    });
}

/**
 * Inject custom data into depositOnCreditHold field
 * Used for testing 'Despoit on Hold' feature
 */
export const injectFundsOnHold = ({ commit, dispatch, state, getters }, { data }) => {
    const acctId = getters.selectedAcctId;
    const currData = getters['portfolio/accountSummary'].find(o => o.acctId == acctId);
    const fundsOnHold = {
        "amount": 0,
        "currency": null,
        "isNull": false,
        "timestamp": 1614627060000,
        "value": data,
        "severity": 0
    };
    if (currData == undefined) {
        commit('portfolio/SET_ACCOUNT_SUMMARY', { acctId: acctId, data: { depositoncredithold: fundsOnHoldfundsOnHold } });
    } else {
        currData.data['depositoncredithold'] = fundsOnHold;
        commit('portfolio/SET_ACCOUNT_SUMMARY', { acctId: acctId, data: currData.data });
    }
}

export const setIserverAccountsAsPickerAccounts = ({ commit, dispatch, state, getters }) => {
    if (getters.pickerAccounts.length) {
        console.debug('Iserver accounts NOT not used as picker accounts as they are already set.');
        return;
    }
    const pickerAccounts = getters['iserverData/accounts'].map(acctId => {
        return {
            accountId: acctId
        };
    });
    // store the accounts
    dispatch('storePickerAccounts', {
        accts: pickerAccounts
    });
    // set the selected account
    const acct = pickerAccounts.find(acct => acct.accountId == getters['iserverData/selectedAccount']);
    dispatch('setSelectedAccounts', {
        accounts: [ acct ]
    });
    console.debug(`Set iserver accounts ${getters['iserverData/accounts']} as picker accounts successfully`);
}
